<template>
  <img :src="iconSrc" :class="$style.icon" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import IconPlanBadgePr from '@/assets/images/icons/badge-pr.svg?url'
import IconPlanBadgeEntry from '@/assets/images/icons/badge-entry.svg?url'
import IconPlanBadgePro from '@/assets/images/icons/badge-pro.svg?url'
import IconPlanBadgeEnterprise from '@/assets/images/icons/badge-enterprise.svg?url'

import { Plan } from '@/types/schema.generated'

const props = defineProps<{ plan: Plan }>()

// 2022_1プランと同じバッジを使う
const iconSrc = computed(() => {
  switch (props.plan) {
    case Plan.V2023_1SkillForce:
      return IconPlanBadgePr
    case Plan.V2023_1Expert:
      return IconPlanBadgeEntry
    case Plan.V2023_1Master:
      return IconPlanBadgePro
    case Plan.V2023_1Enterprise:
      return IconPlanBadgeEnterprise
    default:
      return undefined
  }
})
</script>

<style lang="scss" module>
.icon {
  width: 1em;
  height: 1em;
}
</style>
